import { Clover, Landmark, X } from 'lucide-react';
import { useState } from 'react';

export function CardReveal({ card }) {
  const [hiddenSequence, setHiddenSequence] = useState(null);
  if (!card || hiddenSequence === card.sequence) return null;
  const isChance = card.deck === 'chance';
  return (
    <div className="card-reveal" role="status">
      <button type="button" onClick={() => setHiddenSequence(card.sequence)} aria-label="Закрыть карточку"><X size={18} /></button>
      <span>{isChance ? <Clover /> : <Landmark />}{isChance ? 'Шанс' : 'Городская казна'}</span>
      <strong>{card.title}</strong>
      <p>{card.description}</p>
    </div>
  );
}
